import { render, staticRenderFns } from "./UsuarioGrupoListaPermissao.vue?vue&type=template&id=4cea254f&scoped=true"
import script from "./UsuarioGrupoListaPermissao.vue?vue&type=script&lang=js"
export * from "./UsuarioGrupoListaPermissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea254f",
  null
  
)

export default component.exports